import React, { useContext } from 'react';
import { useStyles } from './styles';
import { InputV2, ButtonV2, Typography, Box } from '@/elements';
import Logo from '../../../components/global/Logo';
import AuthWrapper from '../../../components/global/Wrappers/authWrapper';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { loadState } from '../../../helpers/localStorage';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';
import { Login, UPDATE_PARTNER_ACCOUNT_EMPLOYEE } from '../../../actions/update';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';

const JoinAccountSecond = () => {
    const classes = useStyles();
    const { id, email, type, password } = loadState('secondStep');
    const navigate = useNavigate();
    const context = useContext(AuthContext);

    const [login] = useMutation(Login, {
        update(_, result) {
            context.login(result.data.login.accessToken);
            navigate('/accounts');
        },
        onError(err) {
            console.log(err);
        },
    });

    const [updateClient] = useMutation(UPDATE_PARTNER_ACCOUNT_EMPLOYEE);

    const onSubmit = data => {
        updateClient({
            variables: {
                email,
                first: data.firstName,
                last: data.lastName,
                id: Number(id),
            },
        })
            .then(() => {
                login({
                    variables: {
                        password,
                        email,
                        type,
                    },
                })
                    .then(() => localStorage.removeItem('secondStep'))
                    .catch(err => console.log(err.message));
            })
            .catch(err => toast.error(err.message));
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required('The field is required').max(100, 'Maximum length is 100 characters'),
        lastName: Yup.string().required('The field is required').max(100, 'Maximum length is 100 characters'),
    });

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onChange',
    });

    return (
        <AuthWrapper>
            <Box justify="center" align="center" direction="column" gap="20px" width="100%">
            <Logo />
            <Typography variant="h6" className={classes.title}>
                Join account
            </Typography>
            <Typography variant="subtitle1">Almost done, just enter your first and last name</Typography>

            <Box justify="center" direction="column" gap="40px" width="100%">
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box direction="column" gap="20px">
                    <Controller
                        name="firstName"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                            <InputV2
                                isError={Boolean(errors.firstName)}
                                onChange={onChange}
                                width={'100%'}
                                value={value}
                                label="First name"
                                placeholder="Enter your first name"
                                helperText={errors?.firstName?.message ?? ' '}
                            />
                        )}
                    />
                    <Controller
                        name="lastName"
                        control={control}
                        defaultValue=""
                        render={({ field: { onChange, value } }) => (
                            <InputV2
                                isError={Boolean(errors.lastName)}
                                onChange={onChange}
                                value={value}
                                label="Last name"
                                width={'100%'}
                                placeholder="Enter your last name"
                                helperText={errors?.lastName?.message ?? ' '}
                            />
                        )}
                    />

                    <Box justify="end">
                        <ButtonV2 type="submit">
                            Join
                        </ButtonV2>
                    </Box>
                </Box>
            </form>
            </Box>
            </Box>
        </AuthWrapper>
    );
};

export default JoinAccountSecond;
